export enum IdpOauth2LoginCodeChallengeMethod {
    PLAIN = 'plain',
    S256 = 'S256'
}
